/**
 * Created by alex on 12.12.2016.
 */
import { ReactElement } from 'react'
import { connect } from 'react-redux'
import join from 'classnames'
import { useIntl } from 'react-intl'
import { Modal } from 'antd'

import styles from './index.module.scss'

import { getGenericError } from 'selectors/app'

import { closeGenericError } from 'actions/app'
import { goTo } from 'actions/location'

interface ReduxProps {
  error: GenericError | null
}

const select = (): ReduxProps => ({
  error: getGenericError(),
})

const GenericError = (props: ReduxProps): ReactElement | null => {
  const { error } = props
  const intl = useIntl()

  if (!error) {
    return null
  }

  const handleOnConfirm = (): void => {
    if (error.confirm?.nextUrl) {
      goTo(error.confirm?.nextUrl)
    }
    closeGenericError()
  }

  const { bodyClassName } = error

  const message = error.messageId
    ? intl.formatMessage({ id: error.messageId })
    : error.message

  return (
    <Modal
      open={true}
      title={error.title}
      onOk={handleOnConfirm}
      onCancel={handleOnConfirm}
      okText={(error.confirm && error.confirm.label) || 'Ok'}
      cancelButtonProps={{ style: { display: 'none' } }}
      className={styles.errorModal}
      width={330}
    >
      <div className={join(styles.errorBody, bodyClassName)}>{message}</div>
    </Modal>
  )
}

export default connect(select)(GenericError)
